
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
	import dialog from '@/components/dialog.vue';
  import {
    activitycouponactivityCouponReceiveInfo,
    activitycoupontransferRecord
  } from "@/api/finance"
  import {
    activitycouponmemberCouponCancel
  } from "@/api/live"
	import Message from '@/components/message.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
			'slz-message': Message,
      'slz-dialog':dialog,
    }
  })

  export default class ProductList extends Vue {
    private keywords = ''
    private state = null
    private statelist = [
      {value:null,label:'全部'},
      {value:0,label:'未使用'},
      {value:1,label:'已使用'},
      {value:2,label:'已过期'},
    ]
    private tablelist:any = []
    private tableloading = false
    private total = 0
    private pageSize = 10
    private pageNo = 1

    private voidShow = false
    private rowmsg:any = {}
    private recordShow = false
    private recordList:any = []
    private recordLoading = false


    private mounted () {
      this.gettablelist()
    }
    



    private async getSendRecord(){
      try{
        this.recordLoading = true
        let res = await activitycoupontransferRecord({
          Id:this.rowmsg.Id,
          Skip:0,
          Take:999
        })
        if(res.IsSuccess){
          this.recordList = res.Result.Results
        }
      }finally{
        this.recordLoading = false
      }
    }
    private sendRecord(row){
      this.rowmsg = row
      this.recordShow = true
      this.getSendRecord()
    }
    private async confirmvoid(){
      try{
        let res = await activitycouponmemberCouponCancel({
          Id:this.rowmsg.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private tocancellation(row){
      this.voidShow = true
      this.rowmsg = row
    }
    private exportfile(){
      let url = location.origin + '/pc/activitycoupon/activityCouponReceiveInfoExport'
      url += '?Keywords=' + encodeURIComponent(this.keywords)
      url += '&Id=' + this.$route.query.Id
      url += '&State=' + (this.state==null?'':this.state)
      window.open(url)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res:any = await activitycouponactivityCouponReceiveInfo({
          Id:this.$route.query.Id,
          Keywords:this.keywords,
          State:this.state,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.canVoid = !((v.StateValue=='已使用'&&new Date(v.EndTime).getTime()<new Date().getTime())||v.StateValue=='已过期')
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.state = null
      this.doSearch()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
  }
